module.exports = __webpack_public_path__ + "img/2.24ba3465.gif";